import React, { useEffect, useState } from 'react';
import { getProjectTrash, restoreProjectTask, deleteProjectTask, emptyProjectTrash, errorMessage } from '../../services/api';
import { useLanguage } from '../../i18n/LanguageContext';
import { fmtDateTime } from '../../utils/format';

const TRASH_DAYS = 30;

/** Cestino del progetto: attività eliminate, ripristinabili per 30 giorni. */
function TrashDialog({ projectId, onClose, onChanged }) {
  const { t } = useLanguage();
  const [tasks, setTasks] = useState(null);
  const [error, setError] = useState('');

  const load = () => getProjectTrash(projectId)
    .then((data) => setTasks(data.tasks))
    .catch((err) => setError(errorMessage(err, t('projectDetail.loadError'))));

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  const act = async (fn) => {
    setError('');
    try {
      await fn();
      await load();
      onChanged();
    } catch (err) {
      setError(errorMessage(err, t('projectDetail.saveError')));
    }
  };

  // Le sotto-attività eliminate insieme al padre si ripristinano con lui: si mostrano solo le radici.
  const ids = new Set((tasks || []).map((task) => task.id));
  const roots = (tasks || []).filter((task) => !task.parent_id || !ids.has(task.parent_id) || tasks.find((p) => p.id === task.parent_id)?.deleted_at !== task.deleted_at);

  return (
    <>
      <div className="pd-modal-overlay" onClick={onClose} />
      <div className="pd-modal pd-trash" role="dialog" aria-label={t('projectDetail.trash')}>
        <h3>{t('projectDetail.trash')}</h3>
        <p className="nt-muted">{t('projectDetail.trashHint', { days: TRASH_DAYS })}</p>
        {error && <div className="error-message">{error}</div>}
        {tasks === null ? <div className="loading">{t('common.loading')}</div> : roots.length === 0 ? (
          <p className="nt-empty">{t('projectDetail.trashEmpty')}</p>
        ) : roots.map((task) => (
          <div key={task.id} className="pd-trash-row">
            <span className="pd-trash-title">{task.title || t('projectDetail.untitled')}</span>
            <span className="nt-muted pd-trash-date">{fmtDateTime(task.deleted_at)}</span>
            <button type="button" className="nt-ghost-btn" onClick={() => act(() => restoreProjectTask(task.id))}>{t('projectDetail.restore')}</button>
            <button type="button" className="nt-ghost-btn" onClick={() => window.confirm(t('projectDetail.deleteForeverConfirm', { name: task.title || t('projectDetail.untitled') })) && act(() => deleteProjectTask(task.id, true))}>{t('projectDetail.deleteForever')}</button>
          </div>
        ))}
        <div className="pd-popover-actions">
          <button type="button" className="btn" onClick={onClose}>{t('projectDetail.close')}</button>
          {roots.length > 0 && (
            <button type="button" className="btn btn-secondary" onClick={() => window.confirm(t('projectDetail.emptyTrashConfirm')) && act(() => emptyProjectTrash(projectId))}>
              {t('projectDetail.emptyTrash')}
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default TrashDialog;
